import { render } from "./vue-particles.vue?vue&type=template&id=87593818"
import script from "./vue-particles.vue?vue&type=script&lang=js"
export * from "./vue-particles.vue?vue&type=script&lang=js"

import "./vue-particles.vue?vue&type=style&index=0&id=87593818&lang=css"

import exportComponent from "/builds/mit/fe/NEWRR/business-fe/global-os/global-retail-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__